import React from "react";
import { Tab, Tabs } from "react-bootstrap-tabs";
import ArtworkCard from "../cardHolders/artworksCardProfile";
import ArtworkCard_ from "../cardHolders/artworksCard";
import Button from "react-bulma-components/lib/components/button";
import Modal from "react-bulma-components/lib/components/modal";
import FollowersList from "./followersList";
import "../../styles/artworks.css";
import { Redirect } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { toast } from 'react-toastify';
import { overFlowHidden, removeOverFlowHidden } from '../../helpers/reusable.js'
import ShareMenu from '../../helpers/shareTheUrl'
import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
const uploadArtIcon = require('../../assets/upload_icon_svg.svg')
const reportDropIcon = require('../../assets/notification_icon copy_svg.svg');

@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'followAndLikeStore')
@observer
export default class ArtistDetails extends React.Component {
    constructor(props) {
        super(props);
        // console.log("Url With Name ", this.props.match.url);
        // const Id = ArtistIdFromUrl(this.props.match.url);
        // console.log("Artist ID", Id);
        this.state = {
            followedThisArtist: false,
            // followedThisArtist: false,
            viewFollowersList: false,
            viewFollowingList: false,
            uploadArt: false,
            readInstructions: false,
            wantsToContinue: false,
            myOwnProfile: false,
            artworkClicked: false,
            artistData: false,
            artistId: false,
            followersList: false,
            followingList: false,
            artist_profile_tags: []


        }
    }
    handelFollowersListClick() {
        // console.log("open follwoers modal");

        this.props.followAndLikeStore.followersList(this.state.artistId)
            .then((res) => {
                console.log(res);
                this.setState({
                    // viewFollowersList: false ,
                    viewFollowersList: !this.state.viewFollowersList,
                    followersList: res.data.data,
                    followersCount: res.data.count
                }, () => overFlowHidden())
            })



    }

    toggleBuyingTab() {
        this.setState({
            buyingTab: "visible",
            sellingTab: "hidden"

        })
        console.log("buying", this.state.buyingTab)
        console.log("selling", this.state.sellingTab)
    }
    toggleSellingTab() {
        this.setState({
            buyingTab: "hidden",
            sellingTab: "visible"

        })
        console.log("buying", this.state.buyingTab)
        console.log("selling", this.state.sellingTab)
    }
    handleArtworkClick() {
        this.setState({
            artworkClicked: !this.state.artworkClicked
        })
    }
    handelFollowingListClick() {
        console.log("open follwing modal")

        this.props.followAndLikeStore.followingList(this.state.artistId)
            .then((res) => {
                console.log(res);
                this.setState({
                    viewFollowingList: !this.state.viewFollowingList,
                    followingList: res.data.data,
                    followingCount: res.data.count
                }, () => overFlowHidden())
            })
    }

    handelFollowRequest() {
        console.log("followed you this is artist data", this.state.followedThisArtist);
        this.setState({
            followedThisArtist: !this.state.followedThisArtist
        }, function () {
            console.log("followed you this is artist data", this.state.followedThisArtist);
            (this.state.followedThisArtist) ?

                this.props.followAndLikeStore.followTheArtist(this.state.artistId)
                    .then((res) => {
                        toast("You are now following this user")
                        this.loadArtistData(this.state.artistId, true)
                    }) :
                this.props.followAndLikeStore.unFollowTheArtist(this.state.artistId)
                    .then((res) => {
                        toast("You have unfollowed this user")
                        this.loadArtistData(this.state.artistId, true)
                    })
        });
    }


    onCloseFollowers() {

        this.setState({
            viewFollowersList: false,
            // followersList: res.data.data,
            // followersCount: res.data.count
        }, () => {
            removeOverFlowHidden()
            this.loadArtistData(this.state.artistId, true)
        })



        // this.componentDidMount()
    }
    onCloseFollowing() {

        this.setState({
            viewFollowingList: false,
            // followingList: res.data.data,
            // followingCount: res.data.count
        }, () => {
            removeOverFlowHidden()
            this.loadArtistData(this.state.artistId, true)
        })


        // this.componentDidMount()
    }
    handleReadInstructionsCheck() {
        console.log("checked")
        this.setState({
            readInstructions: !this.state.readInstructions
        })
    }
    close = () => this.setState({ uploadArt: false });

    handelUploadArtBtnClick() {

        // console.log("set upload art true")
        this.setState({
            uploadArt: !this.state.uploadArt
        })
    }

    handelContinueClick() {
        this.setState({
            wantsToContinue: !this.state.wantsToContinue
        })
    }

    componentDidMount() {
        console.log("mounted profile recieved", this.props.details)
        var str = this.props.details.id;

        if (localStorage.hasOwnProperty("userData")) {
            this.loadArtistData(str)
        }



    }
    loadArtistData(id, hide) {

        this.props.artistDetails.getArtistDetailsPrivate(id, hide)
            .then((resp) => {
                console.log("this is artist data", resp);
                this.setState({
                    artworkCount: resp.data.count,
                    artistData: resp.data.data,
                    followedThisArtist: (resp.data.count) ? resp.data.data[0].isfollowing : resp.data.data.user_profile.isfollowing,
                    artistId: id,
                    myOwnProfile: (id == localStorage.getItem("profile_id"))
                }, () => {
                    console.log("this is artist data", this.state.artistData)
                    // var tags = [];
                    /* user tags logic */
                    if (this.state.artistData && this.state.artistData[0]) {
                        this.artistProfileTagsIdentifier(this.state.artistData[0])
                    }
                    else if (this.state.artistData) {
                        this.artistProfileTagsIdentifier(this.state.artistData)
                    }
                }
                )
            })

        this.props.followAndLikeStore.followersList(id)
            .then((res) => {
                console.log(res);
                this.setState({

                    followersList: res.data.data
                })
            })

        this.props.followAndLikeStore.followingList(id)
            .then((res) => {
                console.log(res);
                this.setState({

                    followingList: res.data.data
                })
            })

        this.props.artworksStore.getArtworkCollection(id, hide)
            .then((resp) => {
                console.log("this is collection data", resp);
                this.setState({
                    collectionCount: resp.data.count,
                    collection: resp.data.data,
                    // followedThisArtist: (resp.data.data.length) ? resp.data.data[0].user_profile.isfollowing : resp.data.data.user_profile.isfollowing,
                    // artistId: str.replace(/\D/g, "")
                }, function () {
                    console.log(resp)
                })
            })
    }
    componentWillReceiveProps(nextProps) {
        console.log('[mounted] srchpage ', nextProps.details)
        var str = nextProps.details.id;
        if (str != this.props.details.id) {

            if (localStorage.hasOwnProperty("userData")) {
                this.setState({
                    // shareUrl: false,
                    artistId: str
                }, () => {
                    // console.log('[mounted] srchpage next', nextProps.match.params.id)
                    if (localStorage.hasOwnProperty("userData")) {
                        this.loadArtistData(str);
                    }
                })
            }




        }

    }
    artistProfileTagsIdentifier(data) {
        var tags = [];
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following == 0) {
            tags.push('NEW USER')
        }
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following > 0) {
            tags.push('EXPLORER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following == 0) {
            tags.push('ARTIST')
        }
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following == 0) {
            tags.push('ART COLLECTOR')
        }
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following > 0) {
            tags.push('ART COLLECTOR')
            tags.push('EXPLORER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following == 0) {
            tags.push('ARTIST')
            tags.push('ART COLLECTOR')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following > 0) {
            tags.push('ARTIST')
            tags.push('EXPLORER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following > 0) {
            tags.push('ARTIST')
            tags.push('ART COLLECTOR')
            tags.push('EXPLORER')
        }
        console.log("[user tags]", tags)
        this.setState({
            shareUrl: false,
            artist_profile_tags: tags
        })
    }
    closeArtistModal() {
        this.props.navigatorStore.closeArtistDetailsModal()
    }
    getImageNameReadInstructions = () => this.state.readInstructions ? 'checked' : 'unchecked'
    render() {
        const imageNameInstructions = this.getImageNameReadInstructions();


        if (this.state.wantsToContinue && this.state.readInstructions) {
            return (
                <Redirect push to="/uploadimage2"></Redirect>
            )
        }
        else if (this.state.wantsToContinue && !this.state.readInstructions) {
            this.props.navigatorStore.openErrorModal("Please read all the instructions first");
            this.setState({
                wantsToContinue: false
            })
        }
        return (
            <Modal style={{ zIndex: "80" }} show={this.props.navigatorStore.openArtistDetails} onClose={this.closeArtistModal.bind(this)} >
                <Modal.Content style={{ height: "auto", width: "90%", zIndex: "80" }}>
                    <img style={{ zIndex: "12" }}
                        onClick={this.closeArtistModal.bind(this)} className="cross-icon-for-fullscreen-image-modal" src={require('../../assets/cross_icon_for_close.png')}></img>
                    <div className="main-container-artist-detail-page">
                        <div className="artist-detail-background">
                            <img style={{ maxHeight: "260px" }} src={require('../../assets/artist_banner.png')} />



                            <div className="title-artist-page">
                            </div>
                            <FollowBtn share_url={(this.state.artistData) ? (this.state.artistData.length) ? this.state.artistData[0].user_profile.share_url : this.state.artistData.user_profile.share_url : ""}
                                myOwnProfile={this.state.myOwnProfile} handelUploadArtBtnClick={this.handelUploadArtBtnClick.bind(this)} followedThisArtist={this.state.followedThisArtist} handelFollowRequest={this.handelFollowRequest.bind(this)} />

                        </div>
                        <ArtistBasicInfo
                            followersCount={this.state.followersCount}
                            followingCount={this.state.followingList}
                            share_url={(this.state.artistData) ? (this.state.artistData.length) ? this.state.artistData[0].user_profile.share_url : this.state.artistData.user_profile.share_url : ""}
                            myOwnProfile={this.state.myOwnProfile}
                            handelUploadArtBtnClick={this.handelUploadArtBtnClick.bind(this)}
                            followedThisArtist={this.state.followedThisArtist}
                            handelFollowRequest={this.handelFollowRequest.bind(this)}
                            artistInfo={this.state.artistData}
                            handelFollowersListClick={this.handelFollowersListClick.bind(this)}
                            handelFollowingListClick={this.handelFollowingListClick.bind(this)}
                            artist_profile_tags={this.state.artist_profile_tags} />
                        <TabsForArtistDetails artworkCount={this.state.artworkCount}
                            toggleBuyingTab={this.toggleBuyingTab.bind(this)}
                            toggleSellingTab={this.toggleSellingTab.bind(this)}
                            ArtworkData={this.state.artistData}
                            collection={this.state.collection}
                            collectionCount={this.state.collectionCount} />
                        <Modal show={this.state.viewFollowersList} onClose={this.onCloseFollowers.bind(this)} >
                            <Modal.Content>
                                {/* followers modal content */}
                                <div className="masterpieces-modal-header pt-20 pb-25 ml-25">
                                    <p className="masterpieces-modal-heading">{this.state.artistData.followers} Followers
                                    <img onClick={this.onCloseFollowers.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../assets/cross_icon_for_close.png')}></img></p>
                                </div>
                                <div className="followers-list-modal-content pt5">
                                    <FollowersList close={this.onCloseFollowers.bind(this)} artistFollowersList={this.state.followersList} id={this.state.artistId} />

                                </div>
                            </Modal.Content>
                        </Modal>
                        <Modal show={this.state.viewFollowingList} onClose={this.onCloseFollowing.bind(this)} >
                            <Modal.Content>
                                {/* following modal content */}
                                <div className="masterpieces-modal-header pt-20 pb-25 ml-25">
                                    <p className="masterpieces-modal-heading">{this.state.artistData.following} Following
                            <img onClick={this.onCloseFollowing.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../assets/cross_icon_for_close.png')}></img></p>
                                </div>
                                <div className="followers-list-modal-content pt5">
                                    <FollowersList close={this.onCloseFollowing.bind(this)} artistFollowersList={this.state.followingList} id={this.state.artistId} following={true} />
                                </div>
                            </Modal.Content>
                        </Modal>
                    </div>
                </Modal.Content>
            </Modal>
        )
    }
}


const FollowBtn = (props) => {
    return (
        (window.localStorage.hasOwnProperty("userData")) ?
            <div style={{ position: "relative" }}>
                <img style={{ display: (props.myOwnProfile) ? "" : "none" }} alt="" className="upload-art-icon" onClick={() => props.handelUploadArtBtnClick} src={uploadArtIcon} />
                {/* <p className="follow-text-artist-page" style={{ display: (props.myOwnProfile) ? "none" : "", opacity: "1" }}>{(props.followedThisArtist) ? "UNFOLLOW" : "FOLLOW"}</p>
                <Button style={{ display: (props.myOwnProfile) ? "none" : "", border: (props.followedThisArtist) ? "1px solid #BEA57C" : "" }} className="follow-btn-artist-page" onClick={props.handelFollowRequest}>
                </Button>
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                        <Button className="masterpieces-secondary-buttons share-button"
                        // onClick={() => this.handleShareButton(this.state.artworkData.share_url)}
                        >SHARE</Button>
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem>
                            <FacebookShareButton url={props.share_url}>
                                <FacebookIcon size={32} round={true} />
                            </FacebookShareButton>

                        </DropdownItem>
                        <DropdownItem>
                            <TwitterShareButton url={props.share_url} >
                                <TwitterIcon size={32} round={true} />
                            </TwitterShareButton>
                        </DropdownItem>
                        <DropdownItem>
                            <WhatsappShareButton url={props.share_url} >
                                <WhatsappIcon size={32} round={true} />
                            </WhatsappShareButton>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown> */}
            </div>
            : <div></div>
    )

}


const ArtistIdFromUrl = (string) => {
    return (
        string.split("-").pop()
    )
}

const ArtistBasicInfo = (props) => {
    let { artistInfo } = props;
    console.log("lool look look", artistInfo);
    return (
        (artistInfo && ((artistInfo.length) ? artistInfo[0].user_profile : artistInfo.user_profile)) ?
            //    artistInfo.map((el, elIndex) =>


            <div className="container artist-container">
                <div className="col-md-12">
                    <div className="row block-above mb-25">
                        <div className="col-md-3">
                            <div className="artistProfileImg" style={{ backgroundColor: "white" }} >
                                <img alt=""
                                    src={((artistInfo.length) ? artistInfo[0].user_profile.image : artistInfo.user_profile.image) || require('../../assets/default_square_picture.png')}
                                    className="artistProfileImg" />
                            </div>
                        </div>
                        <div className="col-md-9 pull-left">

                            <div className="row pl-0 name-with-button-block">

                                <div className="col-12 col-md-5 pl-0 pr-0">
                                    <div className="Artistname">
                                        <h3 className="artist-name-text" style={{
                                            minHeight: "0.5em"
                                        }}>
                                            {
                                                (artistInfo.length) ?
                                                    (artistInfo[0].user_profile.display_name) ? artistInfo[0].user_profile.display_name : artistInfo[0].user_profile.old_display_name
                                                    :
                                                    (artistInfo.user_profile.display_name) ? artistInfo.user_profile.display_name : artistInfo.user_profile.old_display_name
                                            }
                                        </h3>
                                    </div>
                                </div>

                                <div className="col-12 col-md-7 xs-pl-0 xs-pr-0 all-btn-block justify-content-end">
                                    <div className="col-12 d-flex justify-content-lg-end justify-content-center height-36" role="group">
                                        <button onClick={props.handelFollowRequest}
                                            style={{
                                                cursor: "pointer",
                                                display: (props.myOwnProfile || !localStorage.hasOwnProperty("userData")) ? "none" : "",
                                                backgroundColor: (props.followedThisArtist) ? "#BEA57C" : "#333333"
                                            }} type="button"
                                            className={"btn follow-btn-new mr-15"}>{(props.followedThisArtist) ? "UNFOLLOW" : "FOLLOW"}</button>
                                        <UncontrolledDropdown nav inNavbar>
                                            <DropdownToggle nav caret style={{ padding: "none" }}>

                                                <button type="button" style={{ color: "black", background: "white" }} className="btn share-btn-new mr-15 mb-15">SHARE</button>
                                            </DropdownToggle>

                                            <ShareMenu share_url={props.share_url} />
                                        </UncontrolledDropdown>
                                        {/* <button type="button" className="btn report-btn-new">
                                            REPORT
                                        </button> */}
                                    </div>
                                </div>
                            </div>


                            <div className="artist-description-block">
                                <div className="col-md-6 pl-0 ">
                                    {
                                        props.artist_profile_tags.map((el) =>
                                            <span className="explorer-design mr-2">
                                                {el}

                                                {/* {(artistInfo.length) ? artistInfo[0].user_profile.ym_profile_tags : artistInfo.user_profile.ym_profile_tags} */}
                                            </span>
                                        )
                                    }

                                    <span className="location">
                                        {(artistInfo.length) ? (artistInfo[0].user_profile && !!artistInfo[0].user_profile.city) ? `${artistInfo[0].user_profile.city}, ` : (artistInfo.user_profile && !!artistInfo.user_profile.city) ? `${artistInfo.user_profile.city}, ` : "" : ""}
                                        {(artistInfo.length) ? artistInfo[0].user_profile.country : artistInfo.user_profile.country}

                                    </span>

                                </div>


                                <div className="col-md-6">
                                    <div className="artist-like-block pull-right">

                                        <Button className="artist-like pull-right" style={{ cursor: "default" }}><b
                                            className="pr-8">{(artistInfo.length) ? artistInfo[0].total_likes_received : artistInfo.user_profile.total_likes_received}</b>
                                            Likes </Button>
                                        <Button className="artist-like pull-right"
                                            onClick={props.handelFollowersListClick}><b
                                                className="pr-8">{(artistInfo.length) ? artistInfo[0].user_profile.followers : artistInfo.user_profile.followers}</b>Followers
                                        </Button>
                                        <Button className="artist-like pull-right"
                                            onClick={props.handelFollowingListClick}><b
                                                className="pr-8">{(artistInfo.length) ? artistInfo[0].user_profile.following : artistInfo.user_profile.following}</b>
                                            Following </Button>

                                    </div>
                                </div>

                            </div>

                            <div className="bio-description">
                                <h5 className="bio-artist" style={{ '-webkit-box-orient': 'vertical' }}>
                                    {(artistInfo.length) ? artistInfo[0].user_profile.bio : artistInfo.user_profile.bio}
                                </h5>
                            </div>

                            <div className="artwork-number text-center one-line">

                            </div>

                        </div>
                    </div>
                </div>
            </div >

            : <div></div>
    )

}

const TabsForArtistDetails = (props) => {
    console.log({ propscoll: props.collection, propdata: props.ArtworkData })
    if (props.collection || props.ArtworkData) {

        if (((props.collection) ? props.collectionCount == 0 ? true : false : true) && ((props.ArtworkData) ? props.artworkCount == 0 ? true : false : true)) {
            return (
                <div className="bg-grey-empty">
                    <div className="d-flex justify-content-center">
                        <div className="rectangle-block">
                            <div className="rectangle-out">
                                <div className="rectangle-in">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <div className="empty-canvas-text">
                            This user’s canvas is currently blank, please check again later.
                            <br />
                            You could follow him to nudge him to publish artworks or to see his collection.
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <Tabs className="tabs" style={{ marginLeft: "30%", margin: "0px auto", minWidth: "100%", justifyContent: "center", flex: 1 }}>
            {/* 25 Artworks */}
            <Tab label={`ARTWORKS ${(props.ArtworkData) ? props.artworkCount || 0 : 0}`} className="tab-button-buying" onClick={props.toggleBuyingTab}  >
                <Artworks ArtworkData={props.ArtworkData} />
            </Tab>
            <Tab label={`COLLECTION ${(props.collection) ? props.collectionCount || 0 : 0} `} className="tab-button-buying" onClick={props.toggleSellingTab}  >
                {/* <div style={{backgroundColor: "#f6f6f6" }}>
                    <div style={{
                        backgroundColor: "#f6f6f6", paddingTop: "3%", maxWidth: "87%", margin: "0px auto"
                        // , display: "flex", flexWrap: "wrap", 
                    }}> */}
                <ArtworksCollectionCard artworkData={props.collection} />

                {/* </div>
                </div> */}
            </Tab>
        </Tabs>
    )

}

const Artworks = (props) => {
    return (
        <div className="artist-artwork-block artwork-detail-block">
            <section className="artworks-detail-section" ref={this.myref}>
                <div className="col-md-12">
                    <div className="row">
                        <div className="tabs-container" style={{ marginTop: "3%" }}>
                            <div className="col-md-12">
                                <div className="row" >
                                    <ArtworkCard artworkData={props.ArtworkData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
const ArtworksCollectionCard = (props) => {
    return (
        <div className="artist-artwork-block artwork-detail-block">
            <section className="artworks-detail-section" ref={this.myref}>
                <div className="col-md-12">
                    <div className="row">
                        <div className="tabs-container" style={{ marginTop: "3%" }}>
                            <div className="col-md-12">
                                <div className="row" >
                                    <ArtworkCard_ artworkData={props.artworkData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}







// WEBPACK FOOTER //
// ./src/components/artist/artistDetailsModal.js